import React from 'react';
import styled from 'styled-components';
import { IconSpinner4 } from '@bynder/icons';
import { iconSizeMedium } from '../../../helpers/iconSizes';
import { useSearchMode } from '../SpotlightState';

export function LoadingIcon() {
	const { canUseSimilaritySearch } = useSearchMode();

	return (
		<StyledDiv
			moveToTheLeft={canUseSimilaritySearch}
			className="spotlightLoader"
			data-testid="spotlightLoadingIndicator"
		>
			<StyledSpinner size={iconSizeMedium} />
		</StyledDiv>
	);
}

const StyledDiv = styled.div<{ moveToTheLeft?: boolean }>`
	right: ${(props) => (props.moveToTheLeft ? '39px !important' : '0px')};
`;

const StyledSpinner = styled(IconSpinner4)`
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
	animation: spin 2s linear infinite;
`;
